















































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { default as DataPanel } from '@/components/DataPanel.vue';
import { default as SearchPanel } from '@/components/SearchPanel.vue';
import StatusPanel from '@/components/StatusPanel.vue';
import BaseInfoPanel from '@/components/BaseInfoPanel.vue';
import { PaginationPanel } from '@/components';
import collapse from '../../utils/collapse.js';
import publicFunc from '../../common/util/publicFunc';
import { ServiceChargeBill } from '@/http';
import { type } from '@/http/interface';
import { enums } from '@/common/enums';
import { formRules } from '@/common/util/validator';

export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        PageDescribe,
        DataPanel,
        PaginationPanel,
        collapse,
        StatusPanel,
        BaseInfoPanel,
        SearchPanel,
    },
})
export default class ServiceBillDetails extends Vue {
    // 验证规则
    public formRules = formRules;
    public isDisabled: boolean = true;
    public publicFunc: any = publicFunc;
    public inquiryType = enums.inquiryType;
    public positionServiceType = enums.positionServiceType;
    public labelPosition: string = 'right';
    public basicForm = {
        code: '',
        month: '',
        amount: 0,
    };
    public activeName: string = 'first';
    public isCost: boolean = true;
    public payType = [
        { key: '1', value: '1', label: '微信' },
        { key: '2', value: '2', label: '支付宝' },
    ];
    public dialogVisible: boolean = false;
    public payTitle: string = '';

    public expandType: boolean = false;
    public loading = false;
    public rePagin = false;
    public total = 0;
    public isActive: boolean = false;
    public form = {
        payer: '',
        payFees: '',
        payTime: '',
        payment: '',
        payContent: '',
    };
    public tableData = [];
    public id: any;
    public async created() {
        this.id = this.$route.query.id;
        this.reload();
    }
    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public $refs: {
        pagination: HTMLFormElement;
        multipleTable: HTMLFormElement;
    };
    /**服务费详情 */
    public totalAmount: number = 0;
    public async reload() {
        this.loading = true;
        await ServiceChargeBill.GetBillDetailList(this.id, {
            ...this.searchValue,
            skip: this.searchPagin.skip,
            count: this.searchPagin.count,
        })
            .then((res) => {
                this.tableData = res.item;
                this.totalAmount = res.totalAmount;
                this.basicForm.code = res.code;
                this.basicForm.month = res.month;
                this.basicForm.amount = res.amount;
                // let skip = this.searchPagin.skip;
                // this.tableData.map((item, index) => {
                //     item.index = skip++ + 1;
                // });
                this.total = res.totalCount;
                this.loading = false;
                this.$refs.pagination.setPage(this.searchPagin.currentPage);
            })
            .catch((err) => {
                this.loading = false;
            });
    }
    timeList = [];
    public handleClick() {
        if (this.activeName == 'first') {
            this.isCost = true;
        } else {
            this.isCost = false;
        }
    }
    public datetimerange(value) {
        if (value) {
            this.searchValue.startTime = value[0];
            this.searchValue.endTime = value[1];
        } else {
            this.searchValue.startTime = null;
            this.searchValue.endTime = null;
        }
    }
    statusArr: any = [];
    public searchValue: any = {
        billNum: '',
        serviceType: '',
        userCompany: '',
        startTime: '',
        endTime: '',
    };

    public resetSearchValue() {
        this.searchValue = {
            billNum: '',
            serviceType: '',
            userCompany: '',
            startTime: '',
            endTime: '',
        };
        this.statusArr = [];
        this.timeList = [];
        this.searchFunc();
    }
    public selectionRow = [] as any;
    public multipleSelection: any;

    selectable(row, rowIndex) {
        //多选框不可勾选
        if (this.selectionRow.find((c) => c.rowIndex === row.rowIndex)) {
            return true;
        } else {
            return false;
        }
    }
    public toSkip() {}
    public async exportExcel() {
        let data = await ServiceChargeBill.BillDetailListExport(this.id, this.searchValue);
    }
    public searchFunc() {
        this.$refs.pagination.handleCurrentChange(1);
        this.searchPagin.skip = 0;
    }

    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        this.reload();
    }
    handleSelectionChange(rows) {
        this.selectionRow = rows; //保存已选择行
        if (rows.length) {
            this.isDisabled = false;
        } else {
            this.isDisabled = true;
        }
    }
    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            //给每一行添加不可枚举属性rowIndex来标识当前行
            value: rowIndex,
            writable: true,
            enumerable: false,
        });
    }
    /** 单选配置 */
    rowClick(row) {
        let refsElTable = this.$refs.multipleTable as any; // 获取表格对象
        let findRow = this.selectionRow.find((c) => c.rowIndex == row.rowIndex);
        if (findRow) {
            refsElTable.toggleRowSelection(row, false);
            return;
        }
        refsElTable.clearSelection();
        refsElTable.toggleRowSelection(row); // 调用选中行方法
    }
    public sort(col): void {
        if (col.order == 'ascending') {
            this.searchValue.asc = true;
        switch (col.prop) {
            case 'serviceTypeStr':
                {
                    this.searchValue.orderBy = '1';
                }
                break;
        }
           this.reload();
        } 
        else if(col.order == "descending") {
            this.searchValue.asc = false;
        switch (col.prop) {
            case 'serviceTypeStr':
                {
                    this.searchValue.orderBy = '1';
                }
                break;
        }
           this.reload();
        }
        else {
            this.searchValue.asc = '';
            this.searchValue.orderBy = '';
            this.reload();
        }
       
    }
    public reset() {
        this.form = {
            payer: '',
            payFees: '',
            payTime: '',
            payment: '',
            payContent: '',
        };
    }
    public addPay() {
        this.payTitle = '新增支付';
        this.dialogVisible = true;
    }
    public addDictForm() {}
    public formClose() {}
    public back() {
        this.$router.push({
            path: '/serviceStatement',
        });
    }
}
